<template>
    <div class="live-dental-advisory-container" id="live-dental-advisory">
        <section class="container">
            <div class="row-custom">
                <div class="team-col">
                    <h1>Aligners</h1>
                    <p>
                        Wilt u uw tanden rechtzetten zonder slotjes? Met aligners bieden wij een comfortabele en vrijwel onzichtbare manier om uw gebit te corrigeren. Tijdens een persoonlijk consult bespreken we uw wensen en maken we een behandelplan op maat. In onze praktijk werken we met SureSmile: een geavanceerd alignersysteem dat met nauwkeurige digitale planning elke stap van uw behandeling voorspelbaar maakt. SureSmile maakt gebruik van 3D-scans en behandelplanning, zodat u vooraf een duidelijk beeld krijgt van het verwachte eindresultaat. Zo werken we stap voor stap aan een rechte, gezonde en zelfverzekerde glimlach.
                    </p>
                    <!-- <a href="" class="hero-btn red-btn">Steun ons</a> -->
                </div>
                <div class="team-col image-col-right">
                    <img src="../assets/images/aligner.jpg" id="the-practice-img">
                </div>
            </div>
        </section>
    </div>
</template>

<script>

export default {
    name: "LiveDentalAdvisory",
    mounted() {
        const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if(entry.isIntersecting){
            entry.target.classList.add('show')
          } 
        })
      })

      const hiddenElements = document.querySelectorAll('.hidden')
      hiddenElements.forEach((el) => observer.observe(el))
    }
}
</script>

<style scoped>
.hidden-first {
  opacity: 0;
  transform: translateX(-100px);
  transition: all 1.5s;
}
.show-first {
  opacity: 1;
  transform: translateX(0);
}
.team-col {
    flex-basis: 48%;
}
.row-custom .image-col-right{
  display: flex;
  justify-content: center;
}

.row-custom {
    margin-bottom: 0px;
}
.team-col img {
    width: 100%;
    max-width: 600px;
}
.team-col h1 {
    padding-top: 0;
    color: var(--blue);
}
.team-col p {
    padding: 15px 0 0;
    font-size: 1.4rem;
}

#the-practice-img {
    width: 100%;
    height: 400px;
    object-fit: cover;
    object-position: center 22%;
    border-radius: 12px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
#the-practice-img {
    width: 100%;
    height: 400px;
    object-fit: cover;
    object-position: center 22%;
}

.oral-hygiene-experts-container {
    padding: 4rem 0;
}


@media(max-width: 991px) {
    .row-custom {
        margin-bottom: 20px;
    }
    .row-custom {
        flex-direction: column;
    }
    h1 {
        font-size: 20px;
        text-align: center;
    }

    .team-col img {
        max-width: 100%;
    }

    .team-col p {
        padding: 7px 0px 0px;
    }

    #the-practice-img {
        height: 200px;
        object-position: center 20%;
    }

}
</style>